import Button from "@/Components/Button";
import Input from "@/Components/Input";
import Label from "@/Components/Label";
import { stringToSlug } from "@/helpers/string";
import { useForm } from "@inertiajs/inertia-react";
import React, { useEffect, useState } from "react";
import Select from "react-select/creatable";

const Create = ({ roles, ...props }) => {

    const [placeholderName, setPlaceholderName] = useState('');

    const { data, setData, post } = useForm({
        'name': '',
        roles_form: []
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value);
    };

    const submit = (event) => {
        event.preventDefault();

        post(route('roles.store'));
    }

    const [optionsSelected, setOptionsSelected] = useState([]);

    useEffect(() => {
        setData('roles_form', optionsSelected.map(e => e.value))
    }, [optionsSelected])

    return (
        <form {...props} onSubmit={submit}>
            <div className="grid grid-cols-2 gap-4 w-full mb-4">
                <div>
                    <Label forInput="name" value="Validación" />
                    <Input name="name" handleChange={onHandleChange} value={data.label} className="w-full" />
                </div>
                <div>
                    <Label forInput="role" value="Validadores" />
                    <Select
                        options={roles.map(role => ({label: role.label, value: role.id}))}
                        isMulti
                        isClearable
                        //menuIsOpen={false}
                        id="role"
                        styles={{
                            indicatorSeparator: () => ({ display: "none" }),
                            input: (styles) => ({
                                ...styles,
                                "> input": {
                                    boxShadow: "none !important",
                                },
                            }),
                        }}
                        className="col-span-8 rounded-md shadow-none"
                        //onKeyDown={handleKeyDown}
                        //onInputChange={(newValue) => setSelectInputValue(newValue)}
                        onChange={(newValue) => {
                            console.log('el value del onchange',newValue)
                            setOptionsSelected(optionsSelected => [...newValue])
                        }}
                        value={ optionsSelected }
                        placeholder="Seleccione un rol."
                        noOptionsMessage={() =>
                            "No hay roles para asignar"
                        }
                        
                    />
                </div>
            </div>

            <Button type="submit">Agregar</Button>
        </form>
    );
};

export default Create;
